/***********************************************************************************
 * Vue Store
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const env = process.env.NODE_ENV;

export const createStore = (): any =>
    new Vuex.Store({
        state: {
            isAuth: false,
            referenceId: null,
            registerId: null,
            origin: null,
            amount: null,
            env: env,
            token: null,
            closeButton: false
        },
        getters: {
            isAuth(state): boolean {
                return state.isAuth;
            },
            getReferenceId(state): string | null {
                return state.referenceId;
            },
            getRegisterId(state): string | null {
                return state.registerId;
            },
            getOrigin(state): string | null {
                return state.origin;
            },
            getAmount(state): number | null {
                return state.amount;
            },
            getEnv(state): any {
                return state.env;
            },
            getToken(state): any {
                return state.token;
            },
            getCloseButton(state): any {
                return state.closeButton;
            }
        },
        mutations: {
            setAuth(state, isAuth: boolean): void {
                state.isAuth = isAuth;
            },
            updateStates(state, data): void {
                if (data.reference_id) {
                    state.referenceId = data.reference_id;
                }

                if (data.register_id) {
                    state.registerId = data.register_id;
                }

                if (data.origin) {
                    state.origin = data.origin;
                }

                if (data.amount) {
                    state.amount = data.amount;
                }
            },
            setToken(state, token: any): void {
                state.token = token;
            },
            setCloseButton(state, enabled: boolean): void {
                state.closeButton = enabled;
            }
        },
        actions: {
            updateAuthStatus({ commit }, isAuth): void {
                commit('setAuth', isAuth);
            },
            updateStatesFromPaymentRequest({ commit }, data): void {
                commit('updateStates', data);
            },
            setToken({ commit }, token): void {
                commit('setToken', token);
            },
            setCloseButton({ commit }, enabled): void {
                commit('setCloseButton', enabled);
            }
        }
    });
